module.exports = __webpack_public_path__ + "q.no1.4c13f81e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/q.no1.jpg
// module id = V7KU
// module chunks = 0